var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('onboarding-buttons');
export var OnboardingButtonsDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: ", ";\n    width: 100%;\n    font-family: ", ";\n  "], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: ", ";\n    width: 100%;\n    font-family: ", ";\n  "])), theme.UNIT(4), theme.FONT('sans'))
});
// -------- Components -------->
var My = {
  NAME: 'OnboardingButtons',
  Container: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var OnboardingButtons = function (props) {
  var componentProps = useComponentProps(My.NAME, OnboardingButtonsDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, children);
};
OnboardingButtons.cls = cls;
var templateObject_1, templateObject_2;